

Greenmile.HoursOfService = Greenmile.HoursOfService || {};
Greenmile.HoursOfService.SummaryInformation = function (selector, hosCollection) {


    var groupByDate = function () {

        var hosModelLength  = 0,
            model,
            hosEventsLength = 0,
            events,
            groupedByDate   = [];

        if (typeof hosCollection !== "undefined") {

            hosModelLength = hosCollection.size();

            for (var i = 0; i < hosModelLength; i++) {

                model = hosCollection.at(i);

                events = model.get("events");

                hosEventsLength = events.length;

                for (var j = 0; j < hosEventsLength; j++) {

                    var date = Monet.Format.Date.formatToISOString(events[j].eventTime);

                    if (groupedByDate[date]) {

                        groupedByDate[date].events.push(events[j]);

                    } else {

                        groupedByDate[date] = { events: [events[j]] };

                    }

                }

            }

            return groupedByDate;

        }

    };

    var formatInformationToSummary = function (date, events) {

        var onDuty   = 0,
            offDuty  = 0,
            lunch    = 0,
            driver   = 0,
            hosBreak = 0,
            wait     = 0,
            isLast   = false,
            endDay   = 0,
            beginDay,
            amountEvents,
            dateGf   = new Monet.Date.GeneralFunctions();

        if (dateGf.checkIfDateIsToday(date)) {

            endDay = new Date().getTime();

        } else {

            endDay = Monet.Format.Date.parse(date).setHours(23, 59, 59, 999);

        }

        beginDay = Monet.Format.Date.parse(date).setHours(0, 0, 0, 0);
        amountEvents = events.length;

        for (var i = 0; i < amountEvents; i++) {

            var typeEventActual = events[i].eventType;
            var dateEventActual = events[i].eventTime;
            var timeEventActual = Monet.Format.DateTime.parse(dateEventActual).getTime();
            var timeEventBefore = null;
            var typeEventBefore = null;
            var diffTime = 0;
            var isFirst = false;
            var dateEventBefore = null;
            var noAddDiffTime = false;

            isLast = i + 1 === amountEvents;

            isFirst = i === 0;

            if (i > 0) {

                typeEventBefore = events[i - 1].eventType;
                dateEventBefore = events[i - 1].eventTime;

                timeEventBefore = Monet.Format.DateTime.parse(dateEventBefore).getTime();

                diffTime = timeEventActual - timeEventBefore;

            }

            if (typeEventActual === "LUNCH_END" && typeEventBefore === "LUNCH_START") {

                lunch += diffTime;

                if (isLast && i === amountEvents - 1) {
                    onDuty += endDay - timeEventActual;
                }

            } else if (typeEventActual === "LUNCH_START" && isLast) {

                lunch += endDay - timeEventActual;
                onDuty += lunch;
                noAddDiffTime = true;

            } else if (typeEventActual === "LUNCH_END" && isFirst) {

                lunch += timeEventActual - beginDay;
                onDuty += lunch;
                noAddDiffTime = true;

            }

            if (typeEventActual === "DRIVING_END" && typeEventBefore === "DRIVING_START") {

                driver += diffTime;

                if (isLast && i === amountEvents - 1) {
                    onDuty += endDay - timeEventActual;
                }

            } else if (typeEventActual === "DRIVING_START" && isLast) {

                driver += endDay - timeEventActual;
                onDuty += driver;
                noAddDiffTime = true;

            } else if (typeEventActual === "DRIVING_END" && isFirst) {

                driver += timeEventActual - beginDay;
                onDuty += driver;
                noAddDiffTime = true;

            }

            if (typeEventActual === "BREAK_END" && typeEventBefore === "BREAK_START") {

                hosBreak += diffTime;

                if (isLast && i === amountEvents - 1) {
                    onDuty += endDay - timeEventActual;
                }

            } else if (typeEventActual === "BREAK_START" && isLast) {

                hosBreak += endDay - timeEventActual;
                onDuty += hosBreak;
                noAddDiffTime = true;


            } else if (typeEventActual === "BREAK_END" && isFirst) {

                hosBreak += timeEventActual - beginDay;
                onDuty += hosBreak;
                noAddDiffTime = true;

            }

            if (typeEventActual === "WAIT_END" && typeEventBefore === "WAIT_START") {

                wait += diffTime;

                if (isLast && i === amountEvents - 1) {
                    onDuty += endDay - timeEventActual;
                }

            } else if (typeEventActual === "WAIT_START" && isLast) {

                wait += endDay - timeEventActual;
                onDuty += wait;
                noAddDiffTime = true;


            } else if (typeEventActual === "WAIT_END" && isFirst) {

                wait += timeEventActual - beginDay;
                onDuty += wait;
                noAddDiffTime = true;

            }

            if (typeEventActual === "ON_DUTY") {

                if (isFirst) {

                    offDuty += timeEventActual - beginDay;

                    if (amountEvents === 1) {

                        onDuty += endDay - timeEventActual;

                    }

                } else if (isLast) {

                    onDuty += endDay - timeEventActual;

                    offDuty += diffTime;

                } else if (typeEventBefore === "OFF_DUTY") {

                    offDuty += diffTime;

                }
            } else if (typeEventActual !== "OFF_DUTY" && !noAddDiffTime) {

                if (isFirst) {

                    onDuty += timeEventActual - beginDay;

                } else {

                    onDuty += diffTime;

                }

            }

            if (typeEventActual === "OFF_DUTY") {

                if (isFirst) {

                    onDuty += timeEventActual - beginDay;

                    if (amountEvents === 1) {

                        offDuty += endDay - timeEventActual;

                    }

                } else if (isLast) {

                    offDuty += endDay - timeEventActual;

                    onDuty += diffTime;

                } else {

                    onDuty += diffTime;

                }

            }

        }

        return {
            onDuty: (new Monet.Format.TIME_LENGTH(onDuty)).convertMillisecondsToHoursAndMinutes().getValue(),
            lunch: (new Monet.Format.TIME_LENGTH(lunch)).convertMillisecondsToHoursAndMinutes().getValue(),
            driver: (new Monet.Format.TIME_LENGTH(driver)).convertMillisecondsToHoursAndMinutes().getValue(),
            hosBreak: (new Monet.Format.TIME_LENGTH(hosBreak)).convertMillisecondsToHoursAndMinutes().getValue(),
            wait: (new Monet.Format.TIME_LENGTH(wait)).convertMillisecondsToHoursAndMinutes().getValue(),
            offDuty: (new Monet.Format.TIME_LENGTH(offDuty)).convertMillisecondsToHoursAndMinutes().getValue()
        };

    };

    this.showSummaryInformation = function () {
        const renderTable = (groupedByDate) => {
            let content = '<div class="logs headerHos">';

            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.dateEvent") + '</div>';
            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.onDuty") + '</div>';
            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.driver") + '</div>';
            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.lunch") + '</div>';
            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.hosBreak") + '</div>';
            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.wait") + '</div>';
            content += '<div class="container">' + Monet.I18n.getResourcesByKey("LogBook.summary.label.offDuty") + '</div>';

            content += '</div>';

            content += '<div class="listLogs">';
            
            for (let date in groupedByDate) {
                const information = formatInformationToSummary(date, groupedByDate[date].events);
                content += '<div class="logs">';
                content += '<div class="container">' + Monet.Format.Date.formatToLocale(date) + '</div>';
                content += '<div class="container">' + information.onDuty + '</div>';
                content += '<div class="container">' + information.driver + '</div>';
                content += '<div class="container">' + information.lunch + '</div>';
                content += '<div class="container">' + information.hosBreak + '</div>';
                content += '<div class="container">' + information.wait + '</div>';
                content += '<div class="container">' + information.offDuty + '</div>';
                content += '</div>';
            }
            content += '</div>';
            return content;
        }

        const renderNoData = () => {
            return `
                <div class='noData'>
                    <div class='noDataIcon'></div>
                    <div class='noDataText'>${Monet.I18n.getResourcesByKey('general.noDataFound')}</div>
                </div>
            `;
        };

        const groupedByDate = groupByDate();
        const container = document.querySelector(selector);
        if (container) {
          container.innerHTML = Object.keys(groupedByDate).length ? renderTable(groupedByDate) : renderNoData();
        }

    };

};
